import { amplitude } from '@/vendor/senn-node-analytics-frontend'
import { AmplitudeLogLevel } from '@/vendor/senn-node-analytics-frontend/types'
import { AMPLITUDE_API_KEY, isUatEnv } from '@/common/config'
import { getStateData, getStateUser } from '@/store'
import { getTenant } from '@/plugins/tenants'
import { executeSafelyWithLogging } from './errors-handler'
import { amplitudeLogger } from './amplitudeLogger'
import { logger } from './logger/loggers'

export function initAnalytics() {
  return executeSafelyWithLogging(() => {
    if (isUatEnv()) {
      logger.warn(
        '[driver-web-app - Analytics]: Amplitude is not available in UAT environment',
        {}
      )
      return
    }
    if (!AMPLITUDE_API_KEY) {
      throw new Error(
        '[driver-web-app - Analytics]: AMPLITUDE_API_KEY not found'
      )
    }
    amplitude.init({
      token: AMPLITUDE_API_KEY,
      appName: 'driver-web-app',
      amplitudeConfig: {
        loggerProvider: amplitudeLogger,
        logLevel: AmplitudeLogLevel.Warn,
      },
    })
  }, 'amplitude.init')
}

export function identifyUserInAnalytics(onLogin: boolean) {
  const analyticsFeaturesFlags = Object.fromEntries(
    Object.entries(getStateData().featureFlags).filter(([flag]) =>
      flag.startsWith('exp')
    )
  )
  const user = getStateUser()

  const analyticsUser = {
    // TODO: Define custom user properties
    tenant: getTenant(),
    userId: user.id.toString(),
    userName: user.username,
    language: user.language,
    ...analyticsFeaturesFlags,
  }

  executeSafelyWithLogging(
    () =>
      // TODO: Define custom group properties
      amplitude.identifyUser(analyticsUser, onLogin, {
        groupType: 'driver-web-app id',
        groupValue: 'driver-web-app group value',
      }),
    'amplitude.identifyUser'
  )
}

export const resetAnalyticsSession = () => {
  executeSafelyWithLogging(() => amplitude.endSession(), 'amplitude.endSession')
  initAnalytics()
}

// Used when the user rejects analytics cookies,
// all user data will be removed from the analytics integration as well as any event submissions will be terminated
export const stopAnalytics = () => {
  executeSafelyWithLogging(
    () => amplitude.stopTracking(),
    'amplitude.stopTracking'
  )
}
